import Button from "@mui/material/Button";
import GuildMultiSelect from "../../Menus/GuildMultiSelect";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {changeProduct} from "./productSlice";
import {addGuildContracts, addGuildContractsBulk} from "./ProductClient";
import {Dialog} from "@mui/material";
import Box from "@mui/material/Box";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";
import {changeWorkQueue} from "../../WorkQueue/workQueueSlice";


export default function ProductGuildDialogue    ({
                                                     selectorGuildMultiSelect,
                                                     handleCancel
                                                 })
{


    const dispatchData = useDispatch();
    const selectorBulkState = useSelector((state) => state.productSlc.value.bulkState);
    const [submitting, setSubmitting] = useState(false);

    const selectorProductId = useSelector((state) => state.productSlc.value.id);


    const [selectedRows, setSelectedRows] = useState([]);


    {
        const [selectedGuilds, setSelectedGuilds] = useState([]);
        const openGuild = selectorGuildMultiSelect;

        const handleGuildSubmit = () => {
            dispatchData(changeWorkQueue({actionMenuState: false }));
            if (selectorBulkState === false) {
                dispatchData(changeProduct({guildMultiSelectState: false}));
                setSubmitting(true);
                dispatchData(changeWorkSubmitting({submitting: true }));
                console.log("what product are we updating?");
                console.log(selectorProductId);
                console.log("what guilds are we submitting?");
                console.log(selectedGuilds);
                console.log("guilds stringified");
                console.log(selectedGuilds.join(', '));
                addGuildContracts(selectorProductId, selectedGuilds.join(','))
                    .then(() => {
                        dispatchData(changeProduct({productGridRefresh: true}));
                        setSubmitting(false);
                        console.log("Successfully added guilds!")
                    })
            } else {
                dispatchData(changeProduct({guildMultiSelectState: false}));
                setSubmitting(true);
                dispatchData(changeWorkSubmitting({submitting: true }));
                console.log("what products are we updating?");
                console.log(selectedRows);
                console.log("products stringified");
                console.log(selectedRows.join(', '));
                console.log("what guilds are we submitting?");
                console.log(selectedGuilds);
                console.log("guilds stringified");
                console.log(selectedGuilds.join(', '));
                addGuildContractsBulk(selectedRows.join(','), selectedGuilds.join(','))
                    .then(() => {
                        dispatchData(changeProduct({productGridRefresh: true}));
                        setSubmitting(false);
                        dispatchData(changeWorkSubmitting({submitting: false }));
                        console.log("Successfully added guilds in bulk!")
                    })
            }
        }

        const handleGuildCancel = () => {
            dispatchData(changeProduct({guildMultiSelectState: false}));
            console.log("guild dialogue close open now")
        };

        return (
            <Dialog
                open={openGuild}
                // open={true}
                onClose={handleGuildCancel} // This will close the dialog when clicking outside or pressing ESC
                // maxWidth="xs" // Controls the maximum width of the dialog
                // fullWidth // Makes the dialog take up the full width allowed by maxWidth
            >
                <Box sx={{padding: 2, width: 500, height: 180}}> {/* Adds some padding inside the dialog */}
                    <p>{selectorBulkState === false ?
                        `Add guild contracts to Product ID: ${selectorProductId}` :
                        'Add guild contracts to selected products'}</p>
                    <GuildMultiSelect
                        selectedGuilds={selectedGuilds}
                        setSelectedGuilds={setSelectedGuilds}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: 2,
                            gap: 1,
                        }}
                    >
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleGuildSubmit} // Connects the submit button to the submit handler
                        >
                            Submit
                        </Button>
                        <Button
                            variant="outlined"
                            // color="secondary"
                            onClick={handleGuildCancel} // Connects the cancel button to the cancel handler
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Dialog>
        );
    }
}